import { buildGenericPropertyComponent } from '../components/GenericPropertyComponent';
import { PropertySchema } from '../PropertySchema';

export const StringProperty = new PropertySchema('string', {
  component: buildGenericPropertyComponent<string>(),

  defaultConfiguration: {
    readOnly: false,
  },
});
